import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IModalProps } from '../../../types/modal/modal-props';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    imports: [CommonModule]
})
export class ConfirmationModalComponent {
  @Input() confirmLabel = 'Discard';
  @Input() modalProps: IModalProps = {
    title: '',
    message: 'Do you want to discard the changes you made to the selected seller offers?',
    subMessage: 'Your changes will be lost if you don’t apply them.',
    icon: 'fa-file-edit',
    buttons: [
      {
        text: 'Discard',
        style: 'btn btn-primary',
        action: () => this.activeModal.close(true)
      },
      {
        text: 'Cancel',
        style: 'btn btn-outline-dark',
        action: () => this.activeModal.close(false)
      }
    ]
  };

  constructor(public activeModal: NgbActiveModal) {}
}
